var styles = {
  "ResourceItem": "Polaris-ResourceItem",
  "Actions": "Polaris-ResourceItem__Actions",
  "ItemWrapper": "Polaris-ResourceItem__ItemWrapper",
  "CheckboxWrapper": "Polaris-ResourceItem__CheckboxWrapper",
  "focusedInner": "Polaris-ResourceItem--focusedInner",
  "focused": "Polaris-ResourceItem--focused",
  "selected": "Polaris-ResourceItem--selected",
  "Link": "Polaris-ResourceItem__Link",
  "Button": "Polaris-ResourceItem__Button",
  "selectable": "Polaris-ResourceItem--selectable",
  "disabled": "Polaris-ResourceItem--disabled",
  "ListItem": "Polaris-ResourceItem__ListItem",
  "hasBulkActions": "Polaris-ResourceItem--hasBulkActions"
};

export { styles as default };
